import { module } from 'modujs';
import { ENV } from "../config";

export default class extends module {
    constructor(m) {
        super(m);

        if (ENV.IS_SM || ENV.IS_MD) return;

        // Options -----
        this.count = this.el.getAttribute('data-count') ? parseInt(this.el.getAttribute('data-count')) : null;
        this.url = this.el.getAttribute('data-folder') ? this.el.getAttribute('data-folder') : null;
        this.pad = this.el.getAttribute('data-pad') ? parseInt(this.el.getAttribute('data-pad')) : 3;
        this.extension = this.el.getAttribute('data-extension') ? this.el.getAttribute('data-extension') : '.avif';
        this.hasHover = this.el.hasAttribute('data-hover');
        this.hasPreload = this.el.hasAttribute('data-preload');
        // -------------

        this.images = [];
        this.img = new Image();
        
        this.currentIndex = 0;

        this.context = null;
        this.canvas = this.createCanvas();

        if (this.hasHover) {
            this.initHover();
        }

        window.addEventListener('resize', () => this.handleResize());
    }

    init() {
        if (ENV.IS_SM || ENV.IS_MD) return;
        
        // Load and draw first image
        this.img.src = this.getImageUrl(0);
        this.images.push(this.img);
        this.img.onload = () => {
            this.render(0);
        };
    }

    createCanvas() {
        let canvas = document.createElement('canvas');
        this.context = canvas.getContext('2d');
        canvas.width = this.el.offsetWidth;
        canvas.height = this.el.offsetHeight;
        
        this.el.appendChild(canvas);
        
        return canvas;
    }

    getImageUrl(index) {
        return this.url + index.toString().padStart(this.pad, '0') + this.extension;
    }

    preload() {
        let img;
        this.images = [];
        for (let index = 0; index < this.count; index++) {
            img = new Image();
            img.src = this.getImageUrl(index);
            this.images.push(img);
        }
    }

    setProgress(progress = 0) {
        if (ENV.IS_SM || ENV.IS_MD) return;

        let newIndex = Math.max(0, Math.min(this.count - 1, Math.ceil(progress * this.count)));
        if (newIndex != this.currentIndex) {
            this.currentIndex = newIndex;
            this.render();
        }
    }

    render(index = this.currentIndex) {
        let img = this.images[index];
        if (!img) return;

        let imgRatio = img.height / img.width;
        let parentRatio = this.el.offsetHeight / this.el.offsetWidth;

        if (imgRatio > parentRatio) {
            let h = this.el.offsetWidth * imgRatio;
            this.context.drawImage(img, 0, (this.el.offsetHeight - h) / 2, this.el.offsetWidth, h);
        }
        if (imgRatio < parentRatio) {
            let w = this.el.offsetWidth * parentRatio / imgRatio;
            this.context.drawImage(img, (this.el.offsetWidth - w) / 2, 0, w, this.el.offsetHeight);
        }
    }

    initHover() {
        this.el.addEventListener('mousemove', (e) => { this.hoverMove(e); }, { passive: true });
    }

    hoverMove(e) {
        const target = e.target;
        const rect = target.getBoundingClientRect();
        const x = e.clientX - rect.left;
        this.setProgress(x / rect.width);
    }

    handleResize() {
        this.canvas.width = this.el.offsetWidth;
        this.canvas.height = this.el.offsetHeight;
        this.render();
    }
}
